const actions = {
	ADD_FILE_LISTS: "ADD_FILE_LISTS",
	addFileLists: payload => ({
		type: actions.ADD_FILE_LISTS,
		payload
	})
}
export default actions
